import { jsx } from "react/jsx-runtime";
import { TaxComparisonTable } from "@zillow/zrs-traffic";
import "react";
const BlockTaxComparisonTable = () => {
  return /* @__PURE__ */ jsx(TaxComparisonTable, {});
};
export {
  BlockTaxComparisonTable as default
};
